<template>
  <hm-col :grid="true" :cols="cols" :hidden="hidden">
    <hm-input id="zipCode"
              :lazy="true"
              v-model="internalValue.zipCode"
              :label="labelZip || this.$t('inputgroups.guestProfileEditor.zipCode')"
              :parent-errors="parentErrors"
              :disabled="disabled"
              :cols="colsZip"
              :hidden="hidden"
              :name="nameZip"/>
    <hm-select v-if="hasLicense('AutoSuggestAddress')"
               id="city"
               ref="city"
               v-model="internalValue.city"
               :label="labelCity || this.$t('inputgroups.guestProfileEditor.city')"
               :disabled="disabled"
               :taggable="true"
               :options="zipCodeData.list"
               :parent-errors="parentErrors"
               :cols="colsCity"
               :name="nameCity"
               :hidden="hidden"
               value-expression="city"
               label-expression="${option.city}"
               @select="onSelectCity"
               @focus="updateZipCodeList">
      <template slot="option" slot-scope="props">
        <table>
          <tr>
            <td v-if="!isEmpty(props.option.city)">{{ props.option.city }}, {{ props.option.state }}, {{ props.option.country_code }}</td>
            <td v-else>{{ props.option.name }}</td>
          </tr>
        </table>
      </template>
    </hm-select>
    <hm-input v-else
              id="city"
              :lazy="true"
              v-model="internalValue.city"
              :label="labelCity || this.$t('inputgroups.guestProfileEditor.city')"
              :disabled="disabled"
              :parent-errors="parentErrors"
              :name="nameCity"
              :hidden="hidden"
              cols="8" />
  </hm-col>
</template>

<script>

import GridMixin from '@/mixins/GridMixin';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil, isEmpty, isEqual, sampleSize, sortBy, isObject } from 'lodash';
import HmTextarea from '../inputs/HmTextarea';
import SpinnerOverlay from '../util/SpinnerOverlay';
import TimerMixin from '../../../mixins/TimerMixin';
import HmSelect from './HmSelect';
import HmCol from '../layout/HmCol';
import HmInput from './HmInput';
import ValidateMixin from '../../../mixins/ValidateMixin';

export default {
  name: 'HmInputZipCity',
  components: { SpinnerOverlay, HmTextarea, HmSelect, HmCol, HmInput },
  mixins: [GridMixin, HotelmeisterMixin, TimerMixin, ValidateMixin],

  props: {
    zip: {
      type: String,
    },
    city: {
      type: String,
    },
    country: {
      type: String,
    },
    id: {
      required: false,
      default: () => {
        const randomString = function (n) {
          return Array(n)
            .fill(null)
            .map(() => (Math.random() < 0.5 ? ((Math.random() * 100) % 25) + 'A'.charCodeAt(0) : ((Math.random() * 100) % 25) + 'a'.charCodeAt(0)))
            .map(a => String.fromCharCode(a))
            .join('');
        };
        return `comp_${isNil(this) || isNil(this._uid) ? randomString(5) : this._uid}`;
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasWarning: {
      type: Boolean,
      required: false,
      default: false,
    },
    cols: {
      type: String,
      default: '12',
    },
    colsZip: {
      type: String,
      default: '4',
    },
    colsCity: {
      type: String,
      default: '8',
    },
    nameZip: {
      type: String,
      default: 'zipCode',
    },
    nameCity: {
      type: String,
      default: 'city',
    },
    labelZip: {
      type: String,
      default: null,
    },
    labelCity: {
      type: String,
      default: null,
    },
    hidden: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      zipCodeData: {
        key: null,
        list: [],
      },
      internalValue: {
        zipCode: null,
        city: null,
        country: null,
      },
    };
  },

  watch: {
    city: function (newVal) { this.internalValue.city = newVal; },
    zip: function (newVal) { this.internalValue.zipCode = newVal; },
    country: function (newVal) { this.internalValue.country = newVal; },
    'internalValue.city': function (newVal) {
      this.$emit('update:city', newVal);
    },
    'internalValue.zipCode': function (newVal) {
      this.$emit('update:zip', newVal);
    },
    'internalValue.country': function (newVal) {
      this.$emit('update:country', newVal);
    },
  },

  created: function () {
    this.internalValue = {
      zipCode: this.zip,
      city: this.city,
      country: this.country,
    };
  },

  methods: {
    isEmpty,
    isNil,
    updateZipCodeList: function () {
      try {
        const zipCode = this.internalValue.zipCode;
        const country = this.internalValue.country;
        if (isEmpty(zipCode)) {
          this.zipCodeData = {
            key: null,
            list: [],
          };
          return;
        }
        const key = `${zipCode}::${country}`;

        if (this.zipCodeData.key === key) return;

        this.axios.get(this.serviceUrls.guest.zipCode(this, zipCode, country))
          .then((response) => {
            this.zipCodeData = {
              key: key,
              list: sortBy(
                Object.values(response.data.data)
                  .flatMap(it => it)
                  .map(it => ({
                    ...it,
                    id: it.city,
                    name: it.city,
                  })),
                'name',
              ) || [],
            };
          })
          .catch(() => {
            this.zipCodeData = {
              key: null,
              list: [],
            };
          });
      } catch (e) {
        this.zipCodeData = {
          key: null,
          list: [],
        };
      }
    },
    onSelectCity(city) {
      try {
        if (!isNil(city) && !isEmpty(city.country_code) && isEmpty(this.internalValue.country)) {
          this.internalValue.country = city.country_code;
        }
      } catch (e) { /* ignore */ }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputZipCity.vue